import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClickToCopy from 'app/scripts/components/features/click-to-copy';
import config from 'config/config';
import classnames from 'classnames';
import { getSpotId } from 'app/scripts/services/app-state';
import endpoints from '../../../libraries/fed-resources/endpoints/moderation';

class EmbedCode extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { html: null, content: null };
    this.toast = this.toast.bind(this);
  }
  componentDidMount() {
    this.generateContent();
  }

  componentDidUpdate(prevProps) {
    if (this.props.themeName !== prevProps.themeName || this.props.type !== prevProps.type) {
      this.generateContent();
    } else if (this.props.isSidebar !== prevProps.isSidebar) {
      let content =
        this.props.type === 'pitc'
          ? this.getPitcCode()
          : this.props.type === 'spotlight'
          ? this.getSpotlightCode()
          : null;
      this.content = content;
      this.setState({ html: content.html, content });
    }
  }

  generateContent = () => {
    var { type } = this.props;
    var content = null;
    switch (type) {
      case 'live-event-1':
        content = this.getLiveEventCode();
        break;
      case 'live-event-2':
        content = this.getLiveEventCode2();
        break;
      case 'reactions':
        content = this.getReactionsCode(false);
        break;
      case 'reactions-sidebar':
        content = this.getReactionsCode(true);
        break;
      case 'pitc':
        content = this.getPitcCode();
        break;
      case 'spotlight':
        content = this.getSpotlightCode();
        break;
      case 'topic-tracker':
        content = this.getTopicTrackerCode();
        break;
      case 'topic-tracker-sidebar':
        content = this.getTopicTrackerCode(true);
        break;
    }
    this.content = content;

    this.setState({ html: content.html, content: content });
  };

  toast() {
    if (this.refs.toast) {
      this.refs.toast.className = 'toast animate';
      setTimeout(() => (this.refs.toast.className = 'toast'), 3000);
    }
  }

  getReactionsCode(isSidebar) {
    let { spotId, themeName } = this.props;
    const html = `<span class="color4">&lt;div</span><span class="color2"> data-spotim-app</span>=<span class="color3">"reactions"</span><span class="color2"> data-spot-id</span>=<span class="color3">"${spotId}"</span><span class="color2"> data-post-id</span>=<span class="color3 yellow-background"> "POST_ID"</span>${
      themeName
        ? `<span class="color2"> data-reactions-theme</span>=<span class="color3 yellow-background">"${themeName}"</span>`
        : ''
    } ${
      isSidebar
        ? '<span class="color2"> data-vertical-view</span>=<span class="color3">"true"</span>'
        : ''
    }<span class="color4">&gt;</span><span class="color4">&lt;/div&gt;</span>`;

    const code = `<div data-spotim-app="reactions" data-spot-id="${spotId}" data-post-id="" ${
      themeName ? `data-reactions-theme="${themeName}"` : ''
    } ${isSidebar ? 'data-vertical-view="true"' : ''} ></div>`;

    return { html, code };
  }

  getTopicTrackerCode(isSidebar) {
    const html = `<span class="color4">&lt;div</span><span class="color2"> data-spotim-module</span>=<span class="color3">"topic-tracker"</span><span class="color2"> data-post-id</span>=<span class="color3 yellow-background">"POST_ID"</span>${
      isSidebar
        ? '<span class="color2"> data-vertical-view</span>=<span class="color3">"true"</span>'
        : ''
    }<span class="color4">&gt;</span><span class="color4">&lt;/div&gt;</span>`;

    const code = `<div data-spotim-module="topic-tracker" data-post-id="" ${
      isSidebar ? 'data-vertical-view="true"' : ''
    }></div>`;

    return { html, code };
  }

  getPitcCode() {
    let { isSidebar } = this.props;
    const html = `<span class="color3">&lt;div data-spotim-module="pitc"${
      isSidebar ? ' data-vertical-view="true"' : ''
    }&lt;/div&gt;</span>`;
    const code = `<div data-spotim-module="pitc"${
      isSidebar ? ' data-vertical-view="true"' : ''
    }></div>`;

    return { html, code };
  }

  getSpotlightCode() {
    let { isSidebar } = this.props;
    const html = `<span class="color3">&lt;div data-conversation-spotlight${
      isSidebar ? ' data-spotlight-sidebar' : ''
    }&gt;&lt;/div&gt;</span>`;
    const code = `<div data-conversation-spotlight${
      isSidebar ? ' data-spotlight-sidebar' : ''
    }></div>`;

    return { html, code };
  }

  getLiveEventCode() {
    let { eventCode, spotId = getSpotId(), showOnly } = this.props;

    if (showOnly && showOnly === 'eventCode') {
      const coloredCode = '<span class="color3">"' + eventCode.trim() + '"</span>';
      return {
        html: coloredCode,
        content: null,
        code: eventCode.trim()
      };
    }

    let url = `${config.api.urls.liveBlog}`;
    // var coloredCode = `<span class="color4">&lt;div</span> <span class="color2">class</span>=<span class="color3">"spot-im-live-blog-module"</span>
    //     <span class="color2">data-spot-id</span>=<span class="color3">"${spotId}"</span>
    //     <span class="color2">data-live-event-code</span>=<span class="color3">"${eventCode}"</span>&gt;<span class="color4">&lt;/div&gt;</span>
    //     <span class="color4">&lt;script</span> <span class="color2">type</span>=<span class="color3">"text/javascript"</span> <span class="color2">src</span>=<span class="color3">"${url}"</span>&gt;<span class="color4">&lt;/script&gt;</span>`;
    // var code = `<div class="spot-im-live-blog-module" data-spot-id="${spotId}" data-live-event-code="${eventCode}"></div><script type="text/javascript" src="${url}"></script>`;

    const attributes = {
      src: `${config.api.launcherOnly}/spot/${spotId}`,
      'data-spotim-module': 'spotim-launcher',
      'data-live-blog': 'true',
      'data-live-event-code': eventCode
    };

    let attributesHtmlCode = ' ';
    let attributesCode = ' ';
    for (let key in attributes) {
      const htmlAttr =
        `<span class="color2">${key}</span>` +
        '=' +
        `<span class="color3">"${attributes[key]}"</span> `;
      attributesHtmlCode += htmlAttr;

      const attr = `${key}="${attributes[key]}" `;
      attributesCode += attr;
    }

    const coloredCode =
      '<span class="color4">&lt;script</span> ' +
      attributesHtmlCode.trim() +
      '<span class="color4">&gt;&lt;/script&gt;</span>';

    const code = `<script ${attributesCode.trim()}></script>`;
    return { html: coloredCode, code };
  }

  getLiveEventCode2() {
    let { eventCode } = this.props;

    const attributes = {
      'data-spotim-module': 'liveblog',
      'data-live-event-code': eventCode
    };

    let attributesHtmlCode = ' ';
    let attributesCode = ' ';
    for (let key in attributes) {
      const htmlAttr =
        `<span class="color2">${key}</span>` +
        '=' +
        `<span class="color3">"${attributes[key]}"</span> `;
      attributesHtmlCode += htmlAttr;

      const attr = `${key}="${attributes[key]}" `;
      attributesCode += attr;
    }

    const coloredCode =
      '<span class="color4">&lt;div</span> ' +
      attributesHtmlCode.trim() +
      '<span class="color4">&gt;&lt;/div&gt;</span>';

    const code = `<div ${attributesCode.trim()}></div>`;

    return { html: coloredCode, code };
  }

  render() {
    var { title, description, className } = this.props;
    var { html, content } = this.state;

    var clickToCopy = null;
    if (content) {
      clickToCopy = <ClickToCopy content={content.code} onCopy={this.toast} />;
    }

    return (
      <div className={classnames('code-embed', className)}>
        <h5 className="code-title">{title}</h5>
        <div className="code-description">{description}</div>
        <div className="code-wrap">
          <span className="toast" ref="toast">
            Copied to clipboard
          </span>
          <div className="code">
            {clickToCopy}
            <div className="gutter">
              <div className="line-numbers">
                1<br />2<br />3<br />4<br />5<br />6<br />7<br />8<br />9<br />
                10
                <br />
                11
                <br />
                12
                <br />
                13
                <br />
                14
                <br />
                15
                <br />
                16
                <br />
                17
                <br />
                18
                <br />
                19
                <br />
                20
                <br />
                21
                <br />
                22
                <br />
                23
                <br />
                24
                <br />
                25
                <br />
                26
                <br />
                27
                <br />
                28
                <br />
                29
                <br />
                30
              </div>
            </div>
            <div className="content" dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
      </div>
    );
  }
}

EmbedCode.displayName = 'EmbedCode';

EmbedCode.defaultProps = {
  enableRepliesControl: false,
  spotId: getSpotId()
};

EmbedCode.propTypes = {
  eventCode: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.string,
  spotId: PropTypes.string,
  enableRepliesControl: PropTypes.bool,
  enableReplies: PropTypes.bool,
  eventId: PropTypes.string,
  isSidebar: PropTypes.bool,
  themeName: PropTypes.string
};

export default EmbedCode;
